export default __webpack_public_path__ + "static/media/onboarding-aside-mb.f78a9e45.png";